import { render } from "./EditArticleView.vue?vue&type=template&id=105fc29b&scoped=true"
import script from "./EditArticleView.vue?vue&type=script&lang=js"
export * from "./EditArticleView.vue?vue&type=script&lang=js"

import "./EditArticleView.vue?vue&type=style&index=0&id=105fc29b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105fc29b"]])

export default __exports__